module.exports = __webpack_public_path__ + "static/media/scroll.d94a26dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/scroll.svg
// module id = 298
// module chunks = 0